import { useState, useEffect, useRef } from 'react';
import { saveFilterState, loadFilterState, clearFilterState } from './filterStateManager';

export const useFilterPersistence = (initialFilters, storageKey = 'filterState') => {
const [filters, setFilters] = useState(() => {
  const savedState = loadFilterState(storageKey);
  if (savedState) {
    return {
      ...initialFilters,
      ...savedState   // ✅ safe merge
    };
  }
  return initialFilters;
});
  
  const [isReady, setIsReady] = useState(false);
  const isMountedRef = useRef(false);
  const isInitialMount = useRef(true);

  // Mark as ready after first render
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      isMountedRef.current = true;
      setIsReady(true);
      console.log(`Filter persistence ready for ${storageKey} with filters:`, filters);
    }
}, [storageKey]);
  // Save state when filters change - but only after initial mount
  useEffect(() => {
    if (!isMountedRef.current || isInitialMount.current) {
      return;
    }

    console.log(`Persisting filters for ${storageKey}:`, filters);
    saveFilterState(filters, storageKey);
  }, [filters, storageKey]);

  const updateFilters = (updates) => {
    setFilters(prev => ({
      ...prev,
      ...updates
    }));
  };

  const resetFilters = () => {
    console.log(`Resetting filters for ${storageKey}...`);
    setFilters(initialFilters);
    clearFilterState(storageKey);
  };

  return {
    filters,
    updateFilters,
    resetFilters,
    isReady
  };
};